import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ErrorModal from './Error/Modal';

export function ErrorControllerImpl({ message, error, title }) {
  if (error) {
    return <ErrorModal message={message} title={title} />;
  }
  return <div />;
}

const errorControllerProps = {
  error: PropTypes.bool.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
};

const errorControllerDefaultProps = {
  message: 'Unexpected Error Occurred. Please reload the page and try again. '
  + 'If the error persists, please contact us at '
  + 'support@pricepointmoves.com.',
  title: 'Unexpected Error Occurred',
};

export {
  errorControllerProps,
  errorControllerDefaultProps,
};

ErrorControllerImpl.propTypes = errorControllerProps;
ErrorControllerImpl.defaultProps = errorControllerDefaultProps;

export function mapStateToProps(state) {
  return {
    error: state.error.error,
    message: state.error.message,
    title: state.error.title,
  };
}

export default connect(mapStateToProps)(ErrorControllerImpl);
